module.exports = __webpack_public_path__ + "img/thankyou.388645bf.svg";